import { CaretDownFilled, CheckCircleOutlined, MinusCircleTwoTone, PlusCircleTwoTone, WarningTwoTone, ZoomInOutlined, ZoomOutOutlined } from "@ant-design/icons";
import { Col, Dropdown, Row, Space, Tooltip, Typography } from "antd";
import { Handle, Position } from "reactflow";
import "reactflow/dist/style.css";

const { Text, Link, Title } = Typography;

function LineageDataSetNode({ data }) {
    return (
        <>
            {data.destination ? <Handle type="target" position={Position.Left} /> : <></>}
            <Row
                style={{
                    flexDirection: "column",
                    flexWrap: false,
                    padding: "0rem 0.5rem",
                    width: "100%",
                    height: "100%",
                    justifyContent: "space-between",
                }}
            >
                <Row style={{ width: "100%" }}>
                    <Row style={{ justifyContent: "space-between", width: "100%" }}>
                        <Col>
                            <Text style={{ fontSize: "8px" }}>{data.title}</Text>
                        </Col>
                        <Col style={{ marginLeft: "1rem" }}>
                            <Space orientation="horizontal" size="small">
                                {data.node.linkedResourceExist ? (
                                    <>
                                        {data.node.isZoom ? (
                                            <Tooltip title={"Zoom-out Dataset"}>
                                                <ZoomOutOutlined style={{ cursor: "pointer", color: "#1990FE" }} onClick={() => data.onZoomOut && data.onZoomOut()} />
                                            </Tooltip>
                                        ) : (
                                            <Tooltip title={"Zoom-in Dataset"}>
                                                <ZoomInOutlined style={{ cursor: "pointer", color: "#1990FE" }} onClick={() => data.onZoomIn && data.onZoomIn()} />
                                            </Tooltip>
                                        )}
                                    </>
                                ) : (
                                    <></>
                                )}
                                <Tooltip title={"Actions"}>
                                    <Dropdown
                                        menu={{
                                            items: [
                                                {
                                                    label: "View",
                                                    key: "View",
                                                    disabled: !data.permission.canView,
                                                    onClick: () => data.onActionClick("VIEW"),
                                                },
                                                {
                                                    label: "Edit",
                                                    key: "Edit",
                                                    disabled: !data.permission.canEdit || data.disableEditAction,
                                                    onClick: () => data.onActionClick("EDIT"),
                                                },
                                            ],
                                        }}
                                    >
                                        <CaretDownFilled style={{ fontSize: "1.2vh", color: "#0E9FFF" }} />
                                    </Dropdown>
                                </Tooltip>
                            </Space>
                        </Col>
                    </Row>
                    <Row style={{ flexDirection: "row", flexWrap: "nowrap" }}>
                        <Col style={{ flexWrap: "nowrap" }}>
                            <Tooltip title={data.name}>
                                <Text ellipsis={true} style={{ fontSize: "10px" }} type="secondary">
                                    {data.name}
                                </Text>
                            </Tooltip>
                        </Col>
                        <Col style={{ paddingLeft: "0.5rem" }}>
                            {data.node.erroredRecordsCount ? <WarningTwoTone twoToneColor="#FF0000" /> : <CheckCircleOutlined style={{ color: "#00cf18" }} />}
                        </Col>
                    </Row>
                </Row>

                <Row style={{ flexDirection: "row", flexWrap: "nowrap" }}>
                    <Col style={{ flex: 1, flexWrap: "nowrap" }}>
                        <Tooltip title={`Total records: ${data.node.recordCount || 0}`}>
                            <Text ellipsis={true} style={{ fontSize: "10px" }}>
                                {data.node.recordCount || 0}
                            </Text>
                        </Tooltip>
                    </Col>
                    {data.node.fields && data.node.fields.length > 0 ? (
                        <>
                            {!data.node.isExpanded ? (
                                <Col style={{ flexWrap: "nowrap" }}>
                                    <Tooltip title="Expand schema fields">
                                        <PlusCircleTwoTone style={{ cursor: "pointer" }} onClick={() => data.onExpand && data.onExpand()} />
                                    </Tooltip>
                                </Col>
                            ) : (
                                <Col style={{ flexWrap: "nowrap" }}>
                                    <Tooltip title="Contract schema fields">
                                        <MinusCircleTwoTone style={{ cursor: "pointer" }} onClick={() => data.onContract && data.onContract()} />
                                    </Tooltip>
                                </Col>
                            )}
                        </>
                    ) : (
                        <></>
                    )}
                </Row>
            </Row>
            {data.source ? <Handle type="source" position={Position.Right} /> : <></>}
        </>
    );
}

export default LineageDataSetNode;
